// extracted by mini-css-extract-plugin
export default {"custom-field":"custom-field--R_StO","custom-NUMERIC":"custom-NUMERIC--sX0ni"};